// React
import * as React from "react";

// Redux
import { connect } from "react-redux";

// MainStore
import { MainStore } from "../stores/MainStore";

// Components
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
// import TextField from '@material-ui/core/TextField';
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { NetworkManager, MethodRequest_e } from "../managers/NetworkManager";
import { DateTimePicker } from "material-ui-pickers";
import { TextField } from "@material-ui/core";

interface State {
  sendPrice: boolean;
  price: number;
  // Step 1
  dateBegin: string;
  dateEnd: string;
  cleaning: string;
  confirmed: string;

  // Step 2
  adultDay: Array<number>;
  adultNight: Array<number>;
  childDay: Array<number>;
  childNight: Array<number>;

  // Step 3
  title: string;
  name: string;
  firstname: string;
  address: string;
  npa: string;
  city: string;
  email: string;
  phone: string;
  errors: Array<any>;
  isFinished: boolean;
  isUpdating: boolean;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

function addDays(date: Date, days: number): Date {
  if (!days) {
    return date;
  }
  date.setDate(date.getDate() + days);

  return date;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(
  class TextProfile extends React.Component<Props, State> {
    /**
     * Creates an instance of UserProfile.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     * @memberof App
     */
    constructor(props: any) {
      super(props);

      this.state = {
        sendPrice: false,
        price: 0,
        // Step 1
        dateBegin: "",
        dateEnd: "",
        cleaning: "",
        confirmed: "",

        //Step 2
        adultDay: [],
        adultNight: [],
        childDay: [],
        childNight: [],

        //Step 3
        title: "",
        name: "",
        firstname: "",
        address: "",
        npa: "",
        city: "",
        email: "",
        phone: "",
        errors: [],
        isFinished: false,
        isUpdating: this.props.location.pathname.includes("Modifier")
      };
    }

    async componentWillMount() {
      if (this.state.isUpdating) {
        await NetworkManager.request(
          `bookings/all/${this.props.match.params.id}`,
          MethodRequest_e.GET
        ).then((b) => {
          console.log("TextProfile -> componentWillMount -> booking", b);

          const allDays = b.reservation.days;

          const aDays = [];
          const aNights = [];
          const cDays = [];
          const cNights = [];

          for (const d of allDays) {
            aDays.push(d.adult_day);
            aNights.push(d.adult_night);
            cDays.push(d.children_day);
            cNights.push(d.children_night);
          }

          this.setState({
            price: b.reservation.price,
            // Step 1
            dateBegin: `${allDays[0].date} ${allDays[0].time}`,
            dateEnd: `${allDays[allDays.length - 1].date} ${
              allDays[allDays.length - 1].time
            }`,
            cleaning: b.reservation.cleaning,
            confirmed: b.reservation.confirmed,

            // Step 2
            adultDay: aDays,
            adultNight: aNights,
            childDay: cDays,
            childNight: cNights,

            // Step 3
            title: b.client.title,
            name: b.client.lastname,
            firstname: b.client.firstname,
            address: b.client.adress,
            npa: b.client.npa,
            city: b.client.city,
            email: b.client.email,
            phone: b.client.phone
          });
        });
      }
    }

    handleChange = () => {
      return (event: React.ChangeEvent<any>) => {
        const key = event.target.name;
        this.setState({ [key]: event.target.value } as any);
      };
    }

    formatDate = (date: any) => {
      const d = new Date(date);
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();

      if (month.length < 2) {
        month = "0" + month;
      }
      if (day.length < 2) {
        day = "0" + day;
      }
      return [year, month, day].join("-");
    }

    getDates = () => {
      const dateArray = new Array();
      let currentDate = new Date(this.state.dateBegin);
      const stopDate = new Date(this.state.dateEnd);
      console.log(currentDate, stopDate);
      while (currentDate <= stopDate) {
        dateArray.push(this.formatDate(new Date(currentDate)));
        currentDate = addDays(currentDate, 1);
        console.log("-----", currentDate);
      }
      return dateArray;
    }

    checkUserValues = () => {
      return async (event: React.MouseEvent<any>) => {
        const errors: any = [];

        this.setState({ errors: errors });

        const errorsNumber = Object.keys(errors).length;

        if (errorsNumber == 0) {
          MainStore.showOverlay(
            `${
              this.state.isUpdating ? "Modification" : "Création"
            } de la réservation en cours...`
          );

          try {
            const dates = this.getDates();
            console.log(dates, this.state);
            const days = [];
            for (let i = 0; i < dates.length; i++) {
              const j = {
                date: dates[i],
                adult_day: this.state.adultDay[i],
                adult_night: this.state.adultNight[i],
                children_day: this.state.childDay[i],
                children_night: this.state.childNight[i]
              };

              if (i == 0) {
                const d = new Date(this.state.dateBegin);
                j["time"] = `${d.getHours() < 10 ? "0" : ""}${d.getHours()}:${
                  d.getMinutes() < 10 ? "0" : ""
                }${d.getMinutes()}:00`;
              }
              if (i + 1 == dates.length) {
                const d = new Date(this.state.dateEnd);
                j["time"] = `${d.getHours() < 10 ? "0" : ""}${d.getHours()}:${
                  d.getMinutes() < 10 ? "0" : ""
                }${d.getMinutes()}:00`;
              }

              days.push(j);
            }
            console.log("checkUserValues -> days", days);

            const data: any = {
              client: {
                title: this.state.title,
                lastname: this.state.name,
                firstname: this.state.firstname,
                adress: this.state.address,
                npa: this.state.npa,
                city: this.state.city,
                email: this.state.email,
                phone: this.state.phone
              },
              reservation: {
                days: days,
                cleaning: this.state.cleaning,
                confirmed: this.state.confirmed
              }
            };
            if(this.state.sendPrice) {
              console.log("SEND PRI");
              data.reservation.price = this.state.price;
            }
            await NetworkManager.request(
              `bookings${
                this.state.isUpdating ? `/${this.props.match.params.id}` : ""
              }`,
              this.state.isUpdating
                ? MethodRequest_e.PUT
                : MethodRequest_e.POST,
              data
            );

          } catch (error) {
            console.log(error);
            MainStore.showNotification(error.text, "bg-col-error");
            const newErrors = {};
            newErrors[error.state] = error.text;
            this.setState({
              errors: newErrors
            } as any);
          } finally {
            MainStore.showNotification("Réservation modifiée avec succès");
            MainStore.goBack(this.props.history.location.pathname);
            this.props.history.goBack();
            MainStore.hideOverlay();
          }
        }
      };
    }

    adaptBeginHour = (date: any) => {
      const d: any = new Date(this.state.dateBegin);
      let offset: number = (date - d) / (1000 * 60 * 60 * 24);

      const { adultDay, adultNight, childDay, childNight } = this.state;

      while (offset < 0) {
        adultDay.push(0);
        adultNight.push(0);
        childDay.push(0);
        childNight.push(0);
        offset++;
      }

      while (offset > 0) {
        adultDay.pop();
        adultNight.pop();
        childDay.pop();
        childNight.pop();
        offset--;
      }
      this.setState({
        dateBegin: date,
        adultDay: adultDay,
        adultNight: adultNight,
        childDay: childDay,
        childNight: childNight,
        sendPrice: false
      });
    }

    adaptEndHour = (date: any) => {
      const d: any = new Date(this.state.dateEnd);
      let offset: number = (date - d) / (1000 * 60 * 60 * 24);
      console.log(offset);

      const { adultDay, adultNight, childDay, childNight } = this.state;

      while (offset > 0) {
        adultDay.push(0);
        adultNight.push(0);
        childDay.push(0);
        childNight.push(0);
        offset--;
      }

      while (offset < 0) {
        adultDay.pop();
        adultNight.pop();
        childDay.pop();
        childNight.pop();
        offset++;
      }
      this.setState({
        dateEnd: date,
        adultDay: adultDay,
        adultNight: adultNight,
        childDay: childDay,
        childNight: childNight,
        sendPrice: false
      });
    }

    /**
     * @description Render the UserProfileView in the Browser
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     * @memberof App
     */
    public render() {
      return (
        <Paper elevation={1} className="form-paper-container">
          <Paper className="box-icon">
            <Icon style={{ color: "#fff" }}>edit</Icon>
          </Paper>
          <Typography
            variant="headline"
            style={{ height: "55px", alignItems: "center", display: "flex" }}
          >
            {this.state.isUpdating ? "Modification" : "Création"} d'une
            réservation
          </Typography>
          <Grid container={true} spacing={16} className="form-container">
            <Grid item={true} xs={12}>
              <Typography variant="subheading">Sélection des dates</Typography>
            </Grid>
            <Grid item={true} xs={6} className="form-field">
              <DateTimePicker
                disabled={true}
                label="Date de début"
                name="dateBegin"
                format="DD.MM.YYYY HH:mm"
                ampm={false}
                value={this.state.dateBegin}
                error={Boolean(this.state.errors["dateBegin"])}
                helperText={this.state.errors["dateBegin"]}
                fullWidth={true}
                onChange={(date) => {
                  this.adaptBeginHour(date);
                }}
              />
            </Grid>
            <Grid item={true} xs={6} className="form-field">
              <DateTimePicker
                disabled={true}
                label="Date de fin"
                name="dateEnd"
                format="DD.MM.YYYY HH:mm"
                ampm={false}
                value={this.state.dateEnd}
                error={Boolean(this.state.errors["dateEnd"])}
                helperText={this.state.errors["dateEnd"]}
                fullWidth={true}
                onChange={(date) => {
                  this.adaptEndHour(date);
                }}
              />
            </Grid>

            <Grid item={true} xs={12}>
              <Typography variant="subheading">Personnes attendues</Typography>
            </Grid>

            {this.state.adultDay.map((value: number, index: number) => {
              return (
                <Grid
                  container={true}
                  spacing={16}
                  className="form-container"
                  key={`day_${index}`}
                >
                  {!(
                    new Date(this.state.dateBegin).getHours() >= 17 &&
                    index == 0
                  ) &&
                    !(
                      new Date(this.state.dateEnd).getHours() <= 10 &&
                      index == this.state.adultDay.length - 1
                    ) && (
                      <Grid
                        item={true}
                        xs={12}
                        md={6}
                        lg={3}
                        key={`adult_day_${index}`}
                      >
                        <TextField
                          label={`Adulte jour ${index + 1}`}
                          name={`adult_day_${index}`}
                          value={this.state.adultDay[index]}
                          error={Boolean(
                            this.state.errors[`adulteDay_${index}`]
                          )}
                          helperText={this.state.errors[`adulteDay_${index}`]}
                          fullWidth={true}
                          onChange={(e: any) => {
                            const newData = [...this.state.adultDay];
                            newData[index] = e.target.value;
                            this.setState({ adultDay: newData });
                          }}
                        />
                      </Grid>
                    )}
                  {!(
                    new Date(this.state.dateEnd).getHours() <= 10 &&
                    index == this.state.adultDay.length - 1
                  ) && (
                    <Grid
                      item={true}
                      xs={12}
                      md={6}
                      lg={3}
                      key={`adult_night_${index}`}
                    >
                      <TextField
                        label={`Adulte nuit ${index + 1}`}
                        name={`adult_night_${index}`}
                        value={this.state.adultNight[index]}
                        error={Boolean(
                          this.state.errors[`adulteNight_${index}`]
                        )}
                        helperText={this.state.errors[`adulteNight_${index}`]}
                        fullWidth={true}
                        onChange={(e: any) => {
                          const newData = [...this.state.adultNight];
                          newData[index] = e.target.value;
                          this.setState({ adultNight: newData });
                        }}
                      />
                    </Grid>
                  )}
                  {!(
                    new Date(this.state.dateBegin).getHours() >= 17 &&
                    index == 0
                  ) &&
                    !(
                      new Date(this.state.dateEnd).getHours() <= 10 &&
                      index == this.state.adultDay.length - 1
                    ) && (
                      <Grid
                        item={true}
                        xs={12}
                        md={6}
                        lg={3}
                        key={`child_day_${index}`}
                      >
                        <TextField
                          label={`Enfant jour ${index + 1}`}
                          name={`child_day_${index}`}
                          value={this.state.childDay[index]}
                          error={Boolean(
                            this.state.errors[`childDay_${index}`]
                          )}
                          helperText={this.state.errors[`childDay_${index}`]}
                          fullWidth={true}
                          onChange={(e: any) => {
                            const newData = [...this.state.childDay];
                            newData[index] = e.target.value;
                            this.setState({ childDay: newData });
                          }}
                        />
                      </Grid>
                    )}
                  {!(
                    new Date(this.state.dateEnd).getHours() <= 10 &&
                    index == this.state.adultDay.length - 1
                  ) && (
                    <Grid
                      item={true}
                      xs={12}
                      md={6}
                      lg={3}
                      key={`child_night_${index}`}
                    >
                      <TextField
                        label={`Enfant nuit ${index + 1}`}
                        name={`child_night_${index}`}
                        value={this.state.childNight[index]}
                        error={Boolean(
                          this.state.errors[`childNight_${index}`]
                        )}
                        helperText={this.state.errors[`childNight_${index}`]}
                        fullWidth={true}
                        onChange={(e: any) => {
                          const newData = [...this.state.childNight];
                          newData[index] = e.target.value;
                          this.setState({ childNight: newData });
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              );
            })}

            <Grid item={true} xs={12}>
              <Typography variant="subheading">
                Personnes de référence
              </Typography>
            </Grid>
            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Nom"
                name="name"
                value={this.state.name}
                error={Boolean(this.state.errors["name"])}
                helperText={this.state.errors["name"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Prénom"
                name="firstname"
                value={this.state.firstname}
                error={Boolean(this.state.errors["firstname"])}
                helperText={this.state.errors["firstname"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Adresse"
                name="address"
                value={this.state.address}
                error={Boolean(this.state.errors["address"])}
                helperText={this.state.errors["address"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={3} className="form-field">
              <TextField
                label="NPA"
                name="npa"
                value={this.state.npa}
                error={Boolean(this.state.errors["npa"])}
                helperText={this.state.errors["npa"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={3} className="form-field">
              <TextField
                label="Localité"
                name="city"
                value={this.state.city}
                error={Boolean(this.state.errors["city"])}
                helperText={this.state.errors["city"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Email"
                name="email"
                value={this.state.email}
                error={Boolean(this.state.errors["email"])}
                helperText={this.state.errors["email"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>
            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Téléphone"
                name="phone"
                value={this.state.phone}
                error={Boolean(this.state.errors["phone"])}
                helperText={this.state.errors["phone"]}
                fullWidth={true}
                onChange={this.handleChange()}
              />
            </Grid>

            <Grid item={true} xs={12} md={6} xl={6} className="form-field">
              <TextField
                label="Prix"
                name="price"
                value={this.state.price}
                fullWidth={true}
                onChange={() => {this.handleChange(); this.setState({sendPrice: true});}}
              />
            </Grid>
          </Grid>
          <Button
            variant="contained"
            className="button-add square"
            onClick={this.checkUserValues()}
          >
            {this.state.isUpdating ? "Modifier" : "Créer"}
          </Button>
        </Paper>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/views/BookingsProfile.tsx